export enum AbsenceInputTypeEnum {
  details,
  full,
  partial,
}
